<script>
    import { onDestroy, onMount } from "svelte";
    import { app } from "../../firebase";
    export let path;
    export let uid = "";
    const db = app.firestore();

    $: _path = (path.path
        ? `/${path.path}`
        : [path, uid].filter((it) => it).join("/")
    ).replace(/\/+/, "/");
    $: validPath = _path.split("/").length % 2 === 1;
    $: _query = validPath && db.doc(_path);

    let subscription;

    let document;

    onMount(() => {
        if (!_query) {
            document = {};
            return;
        }
        subscription = _query.onSnapshot(
            (doc) => {
                const data = { uid: doc.id, _exists: doc.exists };
                const docData = doc.data();
                if (docData)
                    Object.entries(docData).forEach(([key, value]) => {
                        if (!value) return;
                        data[key] = value.toDate ? value.toDate() : value;
                    });
                document = data;
            },
            (error) => {
                document = { uid: _query.id, _error: error };
                console.error(error);
            }
        );
    });

    onDestroy(() => {
        if (subscription) subscription();
    });
</script>

{#if document}
    <slot {document} />
{/if}
